import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
  effect,
} from "@angular/core";
import { WorkflowUpdatesDto } from "../../../core/models/project-workflow/workflowUpdatesDto";
import { WorkflowUpdatesPinRequestDto } from "../../../core/models/project-workflow/workflowUpdatesPinRequestDto";
import { WorkflowUpdatesResponseDto } from "../../../core/models/project-workflow/workflowUpdatesResponseDto";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { SignalRService } from "../../../core/services/signal-r.service";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TabsModule } from "primeng/tabs";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { TextareaModule } from "primeng/textarea";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";

@Component({
  selector: "jni-workflow-updates",
  templateUrl: "./workflow-updates.component.html",
  styleUrls: ["./workflow-updates.component.scss"],
  imports: [
    FormsModule,
    CommonModule,
    TabsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    TextareaModule,
    CheckboxModule,
  ],
})
export class WorkflowUpdatesComponent implements OnInit, AfterViewInit {
  @Input() projectWorkflowId = 0;
  @Input() isWorkflowOwners = true;
  @Input() isDisableLink = false;
  update = "";
  workflowUpdatesList = [] as WorkflowUpdatesResponseDto[];
  workflowUpdatesPinnedList = [] as WorkflowUpdatesResponseDto[];
  @Output() showSmalLoaderEvent = new EventEmitter<boolean>();
  @Output() hasUnsavedChangesEvent = new EventEmitter<boolean>();

  @ViewChild("updatesContainer") updatesContainer!: ElementRef;

  personnelNumber = "";
  pinned = false;
  activeIndex = 1;
  constructor(
    private _productionWorkflowService: ProjectWorkflowService,
    private _toastr: JniToastrService,
    private _signalRService: SignalRService
  ) {
    effect(() => {
      const updates = this._signalRService.updates();
      if (updates) {
        this.getWorkflowUpdatesList();
      }
    });
  }

  ngOnInit() {
    this.getWorkflowUpdatesList();
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  postWorkflowUpdate() {
    this.showSmalLoaderEvent.emit(true);
    const payload = {} as WorkflowUpdatesDto;
    if (!this.update || this.update === "") {
      this._toastr.error("Error", "Enter a message to post Updates");
      this.showSmalLoaderEvent.emit(false);
      return;
    }
    payload.message = this.convertLinksToAnchorTags(this.update);
    payload.projectWorkFlowId = this.projectWorkflowId;
    this._productionWorkflowService.postWorkflowUpdates(payload).subscribe({
      next: res => {
        if (res?.status !== "Success") {
          this._toastr.error("Error", "Update was not saved");
        }
        this.update = "";
        this.scrollToBottom();
        this.getWorkflowUpdatesList();
        this.hasUnsavedChangesEvent.emit(false);
      },
      error: res => {
        this._toastr.error("Error", res.message);
        this.showSmalLoaderEvent.emit(false);
      },
    });
  }

  getWorkflowUpdatesList(scroll = true) {
    if (this.projectWorkflowId !== 0) {
      this._productionWorkflowService
        .getWorkflowUpdatesList(this.projectWorkflowId)
        .subscribe({
          next: res => {
            if (res?.totalRecords && res.totalRecords > 0) {
              this.workflowUpdatesList = res.data;
              this.workflowUpdatesPinnedList = res.data.filter(x => x.pinned);
              if (scroll) {
                setTimeout(() => this.scrollToBottom(), 0);
              }
            }

            if (this.workflowUpdatesPinnedList.length === 0) {
              this.activeIndex = 0;
            }

            this.showSmalLoaderEvent.emit(false);
          },
          error: res => {
            this._toastr.error("Error", res.message);
            this.showSmalLoaderEvent.emit(false);
          },
        });
    } else {
      this.workflowUpdatesList = [];
    }
  }

  scrollToBottom(): void {
    this.updatesContainer.nativeElement.scrollTop =
      this.updatesContainer.nativeElement.scrollHeight;
  }

  convertLinksToAnchorTags(text: string): string {
    const urlRegex = /(?:https?:\/\/|www\.)[^\s/$.?#].[^\s]*/gi;

    return text.replace(urlRegex, match => {
      const href = match.startsWith("www.") ? `http://${match}` : match; // Ensure proper protocol
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
    });
  }

  onValueChange() {
    this.hasUnsavedChangesEvent.emit(true);
  }

  onChecked(event: CheckboxChangeEvent, recordId: number) {
    const isChecked = event.checked;
    const payload = {
      recordId: recordId,
      pinStatus: isChecked,
    } as WorkflowUpdatesPinRequestDto;
    this._productionWorkflowService
      .setWorkflowUpdatePinStatus(payload)
      .subscribe({
        next: res => {
          if (res?.data) {
            this.getWorkflowUpdatesList(false);
          }
        },
        error: res => {
          this._toastr.error("Error", res.message);
        },
      });
  }
}
